import { createPopper } from '@popperjs/core';
import bootstrap from 'bootstrap';
$ = window.$ = window.jQuery = require('jquery');

import smoothScroll from 'jquery-smooth-scroll/src/jquery.smooth-scroll';
$('a[href*="#"]').smoothScroll({
    offset: -200,
    speed: 350
});
